import { Box, VStack, spaces } from '@cdl/heartbeat-react';
import { Routes } from 'react-router-dom';
import { generateId } from '../../../shared/utils/generate-id';
import { useCoreListener } from '../hooks/useCoreListener';
import { useRoutes } from '../hooks/useRoutes';
import { TOOLBOX_HEIGHT, Toolbox } from './Toolbox';
import { HEADER_HEIGHT } from './Page';

const HEADER_HEIGHT_WITH_SPACING = `(${HEADER_HEIGHT} + ${spaces.m})`;
const TOOLBOX_HEIGHT_WITH_SPACING = `(${TOOLBOX_HEIGHT} + ${spaces.m})`;
const DELINEATION_SPACING_BOTTOM = spaces.m;

export const Delineation: React.FC = () => {
  const plotId = generateId('delineationPlotId');
  useCoreListener(plotId);
  const routes = useRoutes();

  return (
    <Box id={plotId} width='73.5%' position='fixed'>
      <VStack alignItems='stretch' p='m' pr={0} spacing='m' zIndex={2}>
        <Toolbox />
        <VStack
          alignItems='stretch'
          spacing='m'
          height={`calc(100vh 
            - ${HEADER_HEIGHT_WITH_SPACING} 
            - ${TOOLBOX_HEIGHT_WITH_SPACING} 
            - ${DELINEATION_SPACING_BOTTOM})`}
          overflow='auto'
        >
          <Routes>{routes}</Routes>
        </VStack>
      </VStack>
    </Box>
  );
};
